<template>
  <div class="popup_in">
    <div class="sms-popup popup">
      <!-- X button -->
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><close-svg /></a>
      </div>
      <!-- Message SVG -->
      <img v-if="!errorOnSend" class="svg" src="/assets/img/svg/message.svg" />
      <!-- Form -->
      <div v-if="!didSubmit && !errorOnSend">
        <div>
          <div class="sms-title title">
            שליחת הודעת טקסט למטופל<br />
            <span class="shrink-font marg-top">{{ patientName }} | </span>
            <span class="shrink-font">ת״ז: {{ patientPassport }}</span>
          </div>
          <textarea
            autofocus
            @focus="inputError = false"
            v-model="messageTxt"
            class="sms-textarea"
            :class="{ error: inputError }"
            name="message"
            id="message"
            :placeholder="placeholderTxt"
          ></textarea>
        </div>
        <div class="flex flex--content--center flex-buttons">
          <a class="sms-cancel-btn" @click.prevent="closePopup">ביטול</a>
          <a class="sms-send-btn bt_blue" @click.prevent="onApprove(messageTxt)"
            >שליחה</a
          >
        </div>
      </div>
      <!-- If error occured after submit -->
      <div v-else-if="!didSubmit && errorOnSend">
        <img class="svg" src="/assets/img/svg/alert.svg" />
        <h2 class="title title--40">
          {{ strippedErrorMsg }}
          <br />
        </h2>
        <div class="flex flex--content--center">
          <a class="bt_blue" @click.prevent="closePopup">סגור</a>
        </div>
      </div>
      <!-- If SMS sent successfully -->
      <div v-else-if="didSubmit && !errorOnSend">
        <h2 class="title y-flex">
          <span>ההודעה נשלחה בהצלחה</span>
          <img src="/assets/img/svg/ok-green.svg" />
        </h2>
        <a class="bt_blue" @click.prevent="closePopup">אישור</a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close-sm.svg";

export default {
  data() {
    return {
      messageTxt: "",
      errorOnSend: false,
      resErrorMsg: "",
      inputError: false,
      didSubmit: false
    };
  },
  props: {
    patientName: {
      required: true,
      type: String
    },
    patientPassport: {
      required: true,
      type: String
    },
    surgId: {
      required: true,
      type: Number
    },
    // content: {
    //   required: true,
    //   type: String
    // },
    eventType: {
      required: true,
      type: String
    }
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    async onApprove(messageTxt) {
      if (messageTxt.length <= 1) return (this.inputError = true);
      const res = await this.$API.sendSmsToPatient(
        this.surgId,
        this.eventType,
        messageTxt
      );
      if (res.data.message_error !== "" && res.data.message_error !== null) {
        this.errorOnSend = true;
        this.errorMsg = res.data.message_error;
      } else this.didSubmit = true;
    },
    closePopup() {
      this.$emit("close");
    },
    handleKeyDown(e) {
      if (e.key === "Escape") this.closePopup();
    }
  },
  computed: {
    /**
     * Strips Html tags from response error message
     */
    strippedErrorMsg() {
      let stripHtmlRegex = /(<([^>]+)>)/gi;
      return this.resErrorMsg.replace(stripHtmlRegex, "");
    },
    placeholderTxt() {
      return this.inputError ? "נא הזן תוכן..." : "לחצ/י כאן להקלדת הודעה";
    }
  },
  components: {
    CloseSvg
  }
};
</script>

<style scoped>
.sms-popup {
  background-color: #fff;
  max-width: 666px;
  border-radius: 15px;
}
.sms-title {
  color: #324997;
  font-size: 42px;
  font-weight: 700;
}
.flex-buttons {
  gap: 13px;
  margin-top: 27px;
  flex-direction: column-reverse;
}
.y-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.error {
  border-color: #b00020;
}
.svg {
  width: 42px;
}
.shrink-font {
  display: inline;
  font-size: 28px;
  font-weight: 300;
}
.marg-top {
  margin-top: 8px;
}
.sms-cancel-btn {
  text-decoration: underline;
  cursor: pointer;
}
.sms-cancel-btn:hover {
  opacity: 0.75;
}
.sms-send-btn {
  min-width: 233px;
  border-radius: 5px;
  text-decoration: none;
  height: 58px;
  line-height: 55px;
}
.sms-textarea {
  border-radius: 5px;
  min-height: 173px;
  background: #dfdfdb;
}
.sms-textarea:focus {
  border-bottom: none !important;
}
@media only screen and (max-width: 1200px) {
  .sms-title {
    color: #324997;
    font-size: 28px;
    font-weight: 700;
  }
  .sms-textarea {
    height: 100px;
  }
  .shrink-font {
    display: block;
    font-size: 24px;
  }
  .flex-buttons {
    flex-direction: column-reverse;
    gap: 10px;
  }
}
</style>
